import React from "react";
import { CircularProgress, Box } from "@mui/material";

const LoadingOverlay = ({ show = false }) => {
  if (!show) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        zIndex: 2000,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CircularProgress size={60} thickness={5} sx={{ color: "#FFD700" }} />
    </Box>
  );
};

export default LoadingOverlay;
